import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Templates from "./pages/Templates";
import GetStarted from "./pages/GetStarted";
import Success from "./pages/Success";
import StudentDeveloper from "./templates/StudentDeveloper";
import PhotographerArtistTemplate from "./templates/Photographer";
import Freelancer from "./templates/Freelancer";
import StartupFounder from "./templates/StartupFounder";
import Layout from "./components/Layout";
import Pricing from "./pages/Pricing";
import Payment from "./pages/Payment";
import About from "./pages/About";

// Optional 404 Page
function NotFound() {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center">
      <h1 className="text-4xl font-bold text-purple-500">404</h1>
      <p className="mt-4 text-lg">Page not found.</p>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/templates" element={<Templates />} />
          <Route path="/get-started" element={<GetStarted />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/success" element={<Success />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/about" element={<About />} />

          {/* Template Routes */}
          
          {/* 404 Fallback */}
          <Route path="*" element={<NotFound />} />
          
        </Route>
        <Route path="/templates/student-dev" element={<StudentDeveloper />} />
          <Route path="/templates/photographer" element={<PhotographerArtistTemplate />} />
          <Route path="/templates/freelancer" element={<Freelancer />} />
          <Route path="/templates/startup-founder" element={<StartupFounder />} />

      </Routes>
    </Router>
  );
}

export default App;
